import { useTranslation } from "../../i18n/LanguageContext";

// Chip-style multi-select. Pass `options` for a flat list (e.g. moods) or
// `groups` for category headers (e.g. genres grouped by Music / Workshops).

function Chip({ active, label, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`rounded-full px-3 py-1.5 text-xs font-semibold transition ${
        active ? "bg-indigo-500 text-white" : "bg-slate-700 text-slate-200 hover:bg-slate-600"
      }`}
    >
      {label}
    </button>
  );
}

function MultiSelect({ options, groups, selected = [], onToggle }) {
  const { t } = useTranslation();
  const isOn = (value) => selected.includes(value);
  const translateOption = (value) =>
    t(`filters.options.${value.toLowerCase().replace(/[^a-z0-9]+/g, " ").trim().replace(/\s+/g, "")}`, value);
  const translateGroup = (value) =>
    t(`filters.groups.${value.toLowerCase().replace(/[^a-z0-9]+/g, "")}`, value);

  if (groups) {
    return (
      <div className="space-y-2">
        {groups.map((group) => (
          <div key={group.label}>
            <p className="mb-1 text-[11px] uppercase tracking-[0.18em] text-slate-400">{translateGroup(group.label)}</p>
            <div className="flex flex-wrap gap-1.5">
              {group.options.map((option) => (
                <Chip
                  key={option}
                  active={isOn(option)}
                  label={translateOption(option)}
                  onClick={() => onToggle(option)}
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="flex flex-wrap gap-1.5">
      {(options || []).map((option) => (
        <Chip
          key={option}
          active={isOn(option)}
          label={translateOption(option)}
          onClick={() => onToggle(option)}
        />
      ))}
    </div>
  );
}

export default MultiSelect;
